import { recommendationLabel } from './candidate-summary-labels';

export const APPLICATION_SKILL_SCORE_STRONG_MIN = 75;
export const APPLICATION_SKILL_SCORE_PARTIAL_MIN = 45;

export function applicationScoreBand(
  score?: number | null
): keyof typeof recommendationLabel | null {
  if (score == null || Number.isNaN(score)) {
    return null;
  }
  if (score >= APPLICATION_SKILL_SCORE_STRONG_MIN) {
    return 'STRONG_MATCH';
  }
  if (score >= APPLICATION_SKILL_SCORE_PARTIAL_MIN) {
    return 'PARTIAL_MATCH';
  }
  return 'WEAK_MATCH';
}

export function formatApplicationSkillScore(score?: number | null): string {
  if (score == null || Number.isNaN(score)) {
    return '';
  }
  const band = applicationScoreBand(score);
  const formatted = Number(score).toFixed(1);
  return band ? `${formatted} · ${recommendationLabel[band]}` : formatted;
}
